(function(global){
  // Visualizer.Helpers.Options module
  const Options = {
    _readColumnsCountFromDom() {
      try {
        const list = document.querySelector('.options-list[visualizer="columnsCount"]')
        if (list) {
          const checked = list.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')
          if (checked) {
            const wrap = checked.closest('.admin__field-option')
            const cls = wrap ? Array.from(wrap.classList || []).find((c) => c.startsWith('data-visualizer-value-')) : null
            if (cls) {
              const n = parseInt(cls.replace('data-visualizer-value-', ''), 10)
              if (Number.isFinite(n) && n > 0) return n
            }
            const v = Number(checked.value)
            if (Number.isFinite(v) && v > 0) return v
          }
        }
        const inp = document.querySelector('[visualizer="columnsCount"]')
        if (inp) {
          const v = Number(inp.value)
          if (Number.isFinite(v) && v > 0) return v
        }
      } catch (e) { /* non-fatal */ }
      return null
    },

    _syncColumnsCountFromDom(config = {}) {
      const domCount = Options._readColumnsCountFromDom()
      if (!Number.isFinite(domCount) || domCount <= 0 || !config) return domCount
      const cfgCount = Number(config['columnsCount'])
      if (!Number.isFinite(cfgCount) || cfgCount !== domCount) {
        config['columnsCount'] = String(domCount)
      }
      return domCount
    },

    // Get current columns count from config or DOM
    _getColumnsCount(config = {}) {
      Options._syncColumnsCountFromDom(config)
      let n = Number(config['columnsCount'])
      if (!Number.isFinite(n) || n <= 0) {
        const domCount = Options._readColumnsCountFromDom()
        if (Number.isFinite(domCount) && domCount > 0) n = domCount
      }
      // Clamp between 1 and 4 as we support up to 4 door groups currently
      if (!Number.isFinite(n) || n <= 0) n = 1
      if (n > 4) n = 4
      return n
    },
    // Internal helper: determine if an element is effectively visible
    _isElementVisible(el) {
      if (!el) return false
      if (!(el instanceof Element)) return false
      if (el.hidden) return false
      const style = window.getComputedStyle(el)
      if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false
      if (el.offsetParent === null && style.position !== 'fixed') return false
      if (el.clientWidth === 0 && el.clientHeight === 0) return false
      return true
    },

    _setHiddenVisualizerValue(key, rawValue, config = {}) {
      if (!key) return
      const normalized = rawValue === undefined || rawValue === null ? '' : String(rawValue)
      try {
        const input = document.querySelector(`input[visualizer="${key}"]`)
        if (input && input.value !== normalized) {
          input.value = normalized
          try { input.dispatchEvent(new Event('input', { bubbles: true })) } catch (eInput) { }
          try { input.dispatchEvent(new Event('change', { bubbles: true })) } catch (eChange) { }
        }
      } catch (err) {
        console.warn('Options._setHiddenVisualizerValue failed:', key, err)
      }
      if (config) config[key] = normalized
    },

    setRunnerMetrics(runnersPayload, config = {}) {
      try {
        const runners = Array.isArray(runnersPayload) ? runnersPayload : []
        const firstRunner = runners[0] || {}
        const totalCount = runners.reduce((sum, runner) => {
          const numeric = Number(
            runner && typeof runner.count === 'number'
              ? runner.count
              : (runner && runner.count != null ? parseFloat(runner.count) : NaN)
          )
          return Number.isFinite(numeric) ? sum + numeric : sum
        }, 0)
        const lengthValue = Number.isFinite(firstRunner?.runnerLength)
          ? firstRunner.runnerLength
          : (firstRunner?.runnerLength != null ? parseFloat(firstRunner.runnerLength) : '')
        Options._setHiddenVisualizerValue('runner-length', Number.isFinite(lengthValue) ? lengthValue : '', config)
        Options._setHiddenVisualizerValue('runner-amount', totalCount, config)
      } catch (err) {
        console.warn('Options.setRunnerMetrics failed:', err)
      }
    },

    // Toggle visibility of Cable Access Holes options (Left, Center, Right).
    // When visible is false, only "No" should remain visible/selectable.
    setCableHoleOptionsVisibility(canFit, config = {}) {
      try {
        const list = document.querySelector('.options-list[visualizer="cable-hole-position"]')
        if (!list) return
        const left = list.querySelector('.data-visualizer-value-left')
        const middle = list.querySelector('.data-visualizer-value-middle')
        const right = list.querySelector('.data-visualizer-value-right')
        const show = !!canFit
        const toggle = (wrap, visible) => {
          if (!wrap) return
          wrap.style.display = visible ? '' : 'none'
          const input = wrap.querySelector('input[type="radio"]')
          if (input) input.disabled = !visible
        }
        ;[left, middle, right].forEach((el) => toggle(el, show))
        // Ensure selection is valid if we just hid current choice
        Options.enforceOptionsVisibility(config)
      } catch (err) {
        console.warn('Options.setCableHoleOptionsVisibility failed:', err)
      }
    },

    _updateShelvesSliderUI(control, input, min, max, current, opts = {}) {
      const impl = global.__dpoJqSliderLayout && global.__dpoJqSliderLayout.updateDpoJqSliderUI
      if (typeof impl === 'function') {
        return impl(control, input, min, max, current, opts)
      }
      console.warn('dpo-jq-slider-layout.js must load before visualizer.options.js')
      return false
    },

    _updateDpoJqUiSliderUI(control, input, min, max, current, opts = {}) {
      return Options._updateShelvesSliderUI(control, input, min, max, current, opts)
    },

    // Apply max shelves limits per column based on configurator restrictions.
    // maxCounts: number[] where index 0 => column 1, etc.
    setShelvesMaxCounts(maxCounts, config = {}) {
      try {
        if (!Array.isArray(maxCounts)) return
        const inputs = document.querySelectorAll('input[visualizer^="shelvesCount-"]')
        inputs.forEach((input) => {
          const name = input.getAttribute('visualizer') || ''
          const match = name.match(/shelvesCount-(\d+)/)
          if (!match) return
          const idx = parseInt(match[1], 10)
          const max = Number(maxCounts[idx - 1])
          if (!Number.isFinite(max)) return

          const prevMax = Number(input.getAttribute('max'))
          const maxChanged = !Number.isFinite(prevMax) || prevMax !== max
          if (maxChanged) input.setAttribute('max', String(max))

          // Compute values safely
          const minAttr = Number(input.getAttribute('min'))
          const min = Number.isFinite(minAttr) ? minAttr : 0
          let current = Number(input.value)
          if (!Number.isFinite(current)) current = 0

          // Clamp current if it exceeds new max
          let valueChanged = false
          if (current > max) {
            current = max
            input.value = String(current)
            valueChanged = true
          }

          // Dispatch events only when needed
          if (valueChanged) {
            input.dispatchEvent(new Event('input', { bubbles: true }))
            input.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (maxChanged) {
            input.dispatchEvent(new Event('change', { bubbles: true }))
          }

          // Update DPO/jQuery UI slider if present
          try {
            const control = input.closest('.control') || input.parentElement
            Options._updateShelvesSliderUI(control, input, min, max, current)
          } catch (uiErr) {
            // Non-fatal: UI sync best-effort
          }
        })
      } catch (err) {
        console.warn('Options.setShelvesMaxCounts failed:', err)
      }
    },

    _updateNoUiSliderUI(control, input, min, max, current) {
      if (!input) return false
      try {
        if (!control) control = input.closest('.control') || input.parentElement
        const target = control ? control.querySelector('.noUi-target') : null
        if (!target) return false
        const handle = target.querySelector('.noUi-handle')
        const slider = target.noUiSlider
        if (slider) {
          try {
            if (typeof slider.updateOptions === 'function') {
              slider.updateOptions({ range: { min: Number(min) || 0, max: Number(max) ?? Number(max) } }, false)
            }
          } catch (e) { /* non-fatal */ }
          try { if (typeof slider.set === 'function') slider.set([current]) } catch (e) { /* ignore */ }
        }
        if (handle) {
          handle.setAttribute('aria-valuemin', String(Number(min) || 0))
          if (Number.isFinite(Number(max))) handle.setAttribute('aria-valuemax', String(Number(max)))
          handle.setAttribute('aria-valuenow', String(current))
          const tip = handle.querySelector('.noUi-tooltip')
          if (tip && tip.textContent !== String(current)) tip.textContent = String(current)
        }
        return true
      } catch (e) {
        return false
      }
    },

    _applyColumnRangeLimit(columnIndex, baseKey, range, { updateSlider = true, config = null } = {}) {
      try {
        if (!Number.isFinite(columnIndex) || columnIndex < 1) return
        if (!baseKey || !range || typeof range !== 'object') return
        const configKey = `${baseKey}-${columnIndex}`
        const selector = `input[visualizer="${configKey}"]`
        const input = document.querySelector(selector)
        if (!input) return

        const normalize = (val) => {
          const num = Number(val)
          return Number.isFinite(num) ? num : undefined
        }

        const desiredMin = normalize(range.min)
        const desiredMax = normalize(range.max)
        const prevMinAttr = normalize(input.getAttribute('min'))
        const prevMaxAttr = normalize(input.getAttribute('max'))
        let minChanged = false
        let maxChanged = false

        if (desiredMin !== undefined && desiredMin !== prevMinAttr) {
          input.setAttribute('min', String(desiredMin))
          minChanged = true
        }
        if (desiredMax !== undefined && desiredMax !== prevMaxAttr) {
          input.setAttribute('max', String(desiredMax))
          maxChanged = true
        }

        const appliedMinAttr = normalize(input.getAttribute('min'))
        const appliedMaxAttr = normalize(input.getAttribute('max'))
        const appliedMin = appliedMinAttr !== undefined ? appliedMinAttr : 0
        const appliedMax = appliedMaxAttr !== undefined ? appliedMaxAttr : appliedMin

        let current = normalize(config && config[configKey])
        if (current === undefined) current = normalize(input.value)
        if (current === undefined) current = appliedMin
        let valueChanged = false
        if (desiredMin !== undefined && current < desiredMin) {
          current = desiredMin
          valueChanged = true
        }
        if (desiredMax !== undefined && current > desiredMax) {
          current = desiredMax
          valueChanged = true
        }
        if (config && (config[configKey] == null || normalize(config[configKey]) === undefined)) {
          config[configKey] = String(current)
        }
        if (normalize(input.value) !== current) valueChanged = true
        if (valueChanged) {
          input.value = String(current)
          if (config) config[configKey] = String(current)
          input.dispatchEvent(new Event('input', { bubbles: true }))
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }

        if (updateSlider !== false && Number.isFinite(appliedMin) && Number.isFinite(appliedMax) && appliedMax >= appliedMin) {
          try {
            const control = input.closest('.control') || input.parentElement
            const synced = Options._updateShelvesSliderUI(control, input, appliedMin, appliedMax, current)
            if (!synced && typeof Options._updateNoUiSliderUI === 'function') {
              Options._updateNoUiSliderUI(control, input, appliedMin, appliedMax, current)
            }
          } catch (uiErr) {
            // Slider sync best-effort
          }
        }
        try {
          const Form = global.Visualizer && global.Visualizer.Helpers && global.Visualizer.Helpers.Form
          if (Form && typeof Form.syncScalarInputDomFromConfig === 'function' && config && config[configKey] != null) {
            Form.syncScalarInputDomFromConfig(input, configKey, config)
          }
        } catch (syncErr) {
          // best-effort
        }
      } catch (err) {
        console.warn('Options._applyColumnRangeLimit failed:', err)
      }
    },

    setColumnRangeLimits(columnsPayload, config = {}) {
      try {
        if (!Array.isArray(columnsPayload)) return
        columnsPayload.forEach((column, idx) => {
          if (!column || typeof column !== 'object') return
          const columnIndex = idx + 1
          const templateCodeRaw = column.templateCode || column.code
          const templateCode = typeof templateCodeRaw === 'string' ? templateCodeRaw.toUpperCase() : templateCodeRaw

          if (column.shelvesCount) {
            Options._applyColumnRangeLimit(columnIndex, 'columnShelvesCount', column.shelvesCount, { config })
          }
          if (column.drawersCount && (templateCode === 'T1' || templateCode === 'T2' || templateCode === 'T5' || templateCode === 'T6' || templateCode === 'T7')) {
            Options._applyColumnRangeLimit(columnIndex, 'columnDrawersCount', column.drawersCount, { config })
          }
          if (column.horizontalDividerHeight && (templateCode === 'T2' || templateCode === 'T5' || templateCode === 'T6' || templateCode === 'T7')) {
            Options._applyColumnRangeLimit(columnIndex, 'columnDividerHeight', column.horizontalDividerHeight, { config })
          }
        })
      } catch (err) {
        console.warn('Options.setColumnRangeLimits failed:', err)
      }
    },

    setFrontStylesAvailability(restriction = {}, config = {}) {
      try {
        const list = document.querySelector('.options-list[visualizer="doors-style"]')
        if (!list) return
        const ensureDoorStyleTooltip = () => {
          if (window.__vizDoorStyleTooltipInit) return
          window.__vizDoorStyleTooltipInit = true

          const tooltip = document.createElement('div')
          tooltip.className = 'visualizer-front-style-tooltip'
          tooltip.setAttribute('aria-hidden', 'true')
          document.body.appendChild(tooltip)

          let activeTarget = null
          const targetSelector = '.options-list[visualizer="doors-style"] .admin__field-option[data-viz-tooltip]'
          const hide = () => {
            activeTarget = null
            tooltip.classList.remove('visualizer-front-style-tooltip--visible')
            tooltip.setAttribute('aria-hidden', 'true')
          }
          const updatePositionFromTarget = (target) => {
            if (!target) return
            const rect = target.getBoundingClientRect()
            const spacing = 12
            const viewportPad = 8
            const tooltipRect = tooltip.getBoundingClientRect()
            const tipW = Math.max(tooltipRect.width || 0, 148)
            const tipH = Math.max(tooltipRect.height || 0, 48)
            const viewportW = window.innerWidth || document.documentElement.clientWidth || 0
            const viewportH = window.innerHeight || document.documentElement.clientHeight || 0

            // Place tooltip below the swatch.
            let x = rect.left + rect.width / 2
            let y = rect.bottom + spacing

            // Clamp horizontally (x is center because translateX(-50%)).
            const minCenter = viewportPad + tipW / 2
            const maxCenter = viewportW - viewportPad - tipW / 2
            if (x < minCenter) x = minCenter
            if (x > maxCenter) x = maxCenter

            // If not enough space below, place above.
            let placement = 'bottom'
            if (y + tipH > viewportH - viewportPad) {
              placement = 'top'
              y = rect.top - spacing
            }
            const minY = viewportPad
            const maxY = viewportH - viewportPad
            if (y < minY) y = minY
            if (y > maxY) y = maxY

            tooltip.style.left = `${x}px`
            tooltip.style.top = `${y}px`
            tooltip.style.transform = placement === 'bottom' ? 'translate(-50%, 0)' : 'translate(-50%, -100%)'
            tooltip.setAttribute('data-side', placement)
          }
          const show = (target) => {
            if (!target) return
            const text = target.getAttribute('data-viz-tooltip')
            if (!text) return
            activeTarget = target
            tooltip.textContent = text
            tooltip.classList.add('visualizer-front-style-tooltip--visible')
            tooltip.setAttribute('aria-hidden', 'false')
            updatePositionFromTarget(target)
          }

          document.addEventListener('mouseover', (evt) => {
            const target = evt.target && evt.target.closest ? evt.target.closest(targetSelector) : null
            if (!target) return
            show(target)
          }, true)

          document.addEventListener('mouseout', (evt) => {
            if (!activeTarget) return
            const related = evt.relatedTarget
            if (related && activeTarget.contains(related)) return
            const from = evt.target && evt.target.closest ? evt.target.closest(targetSelector) : null
            if (from && from === activeTarget) hide()
          }, true)

          document.addEventListener('focusin', (evt) => {
            const target = evt.target && evt.target.closest ? evt.target.closest(targetSelector) : null
            if (!target) return
            show(target)
          }, true)

          document.addEventListener('focusout', (evt) => {
            if (!activeTarget) return
            const related = evt.relatedTarget
            if (related && activeTarget.contains(related)) return
            hide()
          }, true)
          window.addEventListener('scroll', () => {
            if (!activeTarget) return
            updatePositionFromTarget(activeTarget)
          }, true)
          window.addEventListener('resize', () => {
            if (!activeTarget) return
            updatePositionFromTarget(activeTarget)
          })
        }
        ensureDoorStyleTooltip()

        const normalizeSupportLevel = (level, isSupported) => {
          const normalized = level == null ? '' : String(level).trim().toLowerCase()
          if (normalized === 'full' || normalized === 'partial' || normalized === 'none') return normalized
          if (isSupported === false) return 'none'
          return 'full'
        }

        const rawStyles = Array.isArray(restriction.allowedStyles) ? restriction.allowedStyles : []
        const normalizedStyles = rawStyles
          .map((item) => {
            const isObj = item && typeof item === 'object' && !Array.isArray(item)
            if (!isObj || item.style == null) return null
            const styleToken = String(item.style).trim().toLowerCase()
            if (!styleToken) return null
            const supportLevel = normalizeSupportLevel(item.supportLevel, item.isSupported)
            return {
              style: styleToken,
              supportLevel: supportLevel
            }
          })
          .filter(Boolean)

        const supportByStyle = normalizedStyles.reduce((acc, item) => {
          acc[item.style] = item
          return acc
        }, {})

        const allowedSet = new Set(
          normalizedStyles
            .filter((item) => item.supportLevel !== 'none')
            .map((item) => item.style)
        )
        const shouldRestrict = normalizedStyles.length > 0

        const getStyleTokens = (wrap, input) => {
          const tokens = []
          if (wrap) {
            const cls = Array.from(wrap.classList || []).find((c) => c.startsWith('data-visualizer-value-'))
            if (cls) tokens.push(cls.replace('data-visualizer-value-', ''))
          }
          if (input && input.value != null) tokens.push(String(input.value))
          return tokens
            .map((v) => (typeof v === 'string' ? v.trim().toLowerCase() : String(v).trim().toLowerCase()))
            .filter(Boolean)
        }

        const reasonText = 'This style requires taller fronts'

        const options = Array.from(list.querySelectorAll('.admin__field-option'))
        options.forEach((wrap) => {
          const input = wrap.querySelector('input[type="radio"]')
          if (!input) return
          if (!input.hasAttribute('data-front-style-base-disabled')) {
            input.setAttribute('data-front-style-base-disabled', input.disabled ? 'true' : 'false')
          }
          const tokens = getStyleTokens(wrap, input)
          const isAllowed = !shouldRestrict || tokens.some((token) => allowedSet.has(token))
          const toReadable = (value) => {
            const str = String(value || '').trim()
            if (!str) return ''
            return str
              .replace(/[-_]+/g, ' ')
              .replace(/\s+/g, ' ')
              .replace(/\b\w/g, (m) => m.toUpperCase())
          }
          const resolveDefaultTooltip = () => {
            const fromCache = wrap.getAttribute('data-style-tooltip-default')
            if (fromCache) return fromCache
            const fromLabel = (() => {
              const node = wrap.querySelector('label span, .admin__field-label span, label, .admin__field-label')
              return node && node.textContent ? node.textContent.trim() : ''
            })()
            const fromNativeTitle =
              wrap.getAttribute('title') ||
              input.getAttribute('title') ||
              ''
            const fromToken = tokens.length > 0 ? toReadable(tokens[0]) : ''
            const resolved = fromLabel || fromNativeTitle || fromToken || 'Style'
            wrap.setAttribute('data-style-tooltip-default', resolved)
            return resolved
          }
          const wasDisabled = input.getAttribute('data-front-style-base-disabled') === 'true'
          const disableByRestriction = !isAllowed
          const finalDisabled = wasDisabled || disableByRestriction
          input.disabled = finalDisabled
          wrap.classList.toggle('front-style-disabled', finalDisabled)
          wrap.setAttribute('aria-disabled', finalDisabled ? 'true' : 'false')
          wrap.style.pointerEvents = finalDisabled ? 'auto' : ''

          if (finalDisabled) {
            wrap.setAttribute('data-viz-tooltip', reasonText)
            wrap.removeAttribute('data-tooltip')
          } else {
            wrap.removeAttribute('data-viz-tooltip')
            wrap.removeAttribute('data-tooltip')
          }
        })

        const selected = list.querySelector('input[type="radio"]:checked')
        if (selected && selected.disabled) {
          const enabledOptions = options.filter((wrap) => {
            const input = wrap.querySelector('input[type="radio"]')
            return input && !input.disabled
          })
          const fallback = enabledOptions.find((wrap) => {
            const input = wrap.querySelector('input[type="radio"]')
            return getStyleTokens(wrap, input).some((token) => token === 'flat')
          }) || enabledOptions[0]
          const fallbackInput = fallback ? fallback.querySelector('input[type="radio"]') : null
          const fallbackValue = fallbackInput ? (getStyleTokens(fallback, fallbackInput)[0] || fallbackInput.value) : ''
          if (fallbackInput && fallbackValue) {
            if (config) config['doors-style'] = fallbackValue
            if (!fallbackInput.checked) {
              fallbackInput.checked = true
              fallbackInput.dispatchEvent(new Event('change', { bubbles: true }))
            }
          }
        }

        try {
          config.__frontStyleRestriction = shouldRestrict
            ? {
                allowedStyles: Array.from(allowedSet),
                supportByStyle: supportByStyle
              }
            : null
        } catch (persistErr) {
          // non-fatal
        }
      } catch (err) {
        console.warn('Options.setFrontStylesAvailability failed:', err)
      }
    },

    setCountertopOverhangSupport(supports = {}, config = {}) {
      try {
        const list = document.querySelector('.options-list[visualizer="countertop-overhang"]')
        if (!list) return

        const normalizeAllowed = (val) => val !== false // default to allowed unless explicitly false

        const applyEdge = (edge) => {
          const allowed = normalizeAllowed(supports?.[edge])
          const wrap = list.querySelector(`.data-visualizer-value-${edge}`) || list.querySelector(`[data-visualizer-value-${edge}]`)
          const input = wrap ? wrap.querySelector('input[type="checkbox"], input[type="radio"]') : list.querySelector(`input[value="${edge}"]`)
          if (!input) return

          // Disable / enable the option
          input.disabled = !allowed
          if (wrap) {
            wrap.setAttribute('aria-disabled', allowed ? 'false' : 'true')
            wrap.style.pointerEvents = allowed ? '' : 'none'
            wrap.style.opacity = allowed ? '' : '0.5'
          }

          // If it was selected while now disallowed, uncheck and notify listeners
          if (!allowed && input.checked) {
            input.checked = false
            input.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (allowed) {
            // Ensure visibility restored when re-allowed
            if (wrap) wrap.style.display = ''
          }
        }

        ;['left', 'right', 'front', 'back'].forEach(applyEdge)

        // Ensure other controls remain coherent after a toggle
        Options.enforceOptionsVisibility(config)
      } catch (err) {
        console.warn('Options.setCountertopOverhangSupport failed:', err)
      }
    },

    setSkirtingCutoutLimits(limits = {}, config = {}) {
      try {
        try {
          config.__skirtingCutoutLimits = limits
        } catch (persistErr) {
        }
        const applyRange = (selector, range) => {
          if (!range) return
          const input = document.querySelector(selector)
          if (!input) return
          const minVal = Number(range.min)
          const maxVal = Number(range.max)
          if (Number.isFinite(minVal)) input.setAttribute('min', String(minVal))
          if (Number.isFinite(maxVal)) input.setAttribute('max', String(maxVal))
          let current = Number(input.value)
          if (!Number.isFinite(current)) current = minVal ?? maxVal ?? 0
          let changed = false
          if (Number.isFinite(minVal) && current < minVal) {
            current = minVal
            input.value = String(current)
            changed = true
          }
          if (Number.isFinite(maxVal) && current > maxVal) {
            current = maxVal
            input.value = String(current)
            changed = true
          }
          if (changed) {
            input.dispatchEvent(new Event('input', { bubbles: true }))
            input.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (Number.isFinite(minVal) || Number.isFinite(maxVal)) {
            input.dispatchEvent(new Event('change', { bubbles: true }))
          }
          try {
            const control = input.closest('.control') || input.parentElement
            let synced = false
            if (Number.isFinite(minVal) && Number.isFinite(maxVal) && maxVal >= minVal) {
              synced = Options._updateShelvesSliderUI(control, input, minVal, maxVal, current)
            }
            if (!synced) {
              Options._updateNoUiSliderUI(control, input, Number.isFinite(minVal) ? minVal : input.getAttribute('min'), Number.isFinite(maxVal) ? maxVal : input.getAttribute('max'), current)
            }
          } catch (sliderErr) {
          }
        }
        applyRange('input[visualizer="cut-out-height"]', limits?.height)
        applyRange('input[visualizer="cut-out-depth"]', limits?.depth)
      } catch (err) {
        console.warn('Options.setSkirtingCutoutLimits failed:', err)
      }
    },

    setAllowedColumnTemplates(allowedTemplates, config = {}) {
      try {
        const normalizeAllowedValues = (raw) => {
          if (Array.isArray(raw)) return raw
          if (typeof raw === 'string') return raw.split(',')
          if (raw && typeof raw === 'object') {
            if (Array.isArray(raw.allowed)) return raw.allowed
            if (Array.isArray(raw.templates)) return raw.templates
            if (Array.isArray(raw.values)) return raw.values
            return Object.entries(raw).flatMap(([key, val]) => {
              if (Array.isArray(val)) return val
              if (val === true) return [key]
              if (typeof val === 'string' || typeof val === 'number') return [val]
              return []
            })
          }
          return []
        }

        const getTemplateTokens = (wrap, input) => {
          const tokens = []
          if (wrap) {
            const cls = Array.from(wrap.classList || []).find((c) => c.startsWith('data-visualizer-value-'))
            if (cls) tokens.push(cls.replace('data-visualizer-value-', ''))
          }
          if (input && input.value != null) tokens.push(String(input.value))
          return tokens
            .map((v) => (typeof v === 'string' ? v.trim() : String(v)))
            .filter(Boolean)
        }

        const lists = document.querySelectorAll('.options-list[visualizer^="columnTemplate-"]')
        lists.forEach((list) => {
          const vis = list.getAttribute('visualizer') || ''
          const m = vis.match(/columnTemplate-(\d+)/i)
          if (!m) return
          const idx = parseInt(m[1], 10)
          const allowedForColumn = Array.isArray(allowedTemplates)
            ? allowedTemplates[idx - 1]
            : (allowedTemplates && typeof allowedTemplates === 'object'
              ? (allowedTemplates[idx] ?? allowedTemplates[String(idx)] ?? allowedTemplates[idx - 1] ?? allowedTemplates[String(idx - 1)] ?? null)
              : null)
          const normalizedAllowed = normalizeAllowedValues(allowedForColumn)
          const allowedSet = new Set(
            (normalizedAllowed || [])
              .map((v) => (typeof v === 'string' ? v.trim() : String(v)))
              .filter(Boolean)
          )

          const options = Array.from(list.querySelectorAll('.admin__field-option'))
          const hasAnyAllowedMatch = options.some((wrap) => {
            const input = wrap.querySelector('input[type="radio"]')
            const tokens = getTemplateTokens(wrap, input)
            return tokens.some((token) => allowedSet.has(token))
          })
          const shouldRestrict = allowedSet.size > 0 && hasAnyAllowedMatch

          options.forEach((wrap) => {
            const input = wrap.querySelector('input[type="radio"]')
            const tokens = getTemplateTokens(wrap, input)
            const isAllowed = !shouldRestrict || tokens.some((token) => allowedSet.has(token))
            wrap.style.display = isAllowed ? '' : 'none'
            if (input) input.disabled = !isAllowed
          })

          const isColumnInterfaceHidden = (node) => {
            let cur = node
            while (cur && cur.nodeType === 1) {
              if (cur.classList && cur.classList.contains('visualizer-column-interface--hidden')) return true
              cur = cur.parentElement
            }
            return false
          }

          const current = list.querySelector('input[type="radio"]:checked')
          if (current) {
            const currentWrap = current.closest('.admin__field-option')
            const currentTokens = getTemplateTokens(currentWrap, current)
            const isAllowedCurrent = !shouldRestrict || currentTokens.some((token) => allowedSet.has(token))
            if (!isAllowedCurrent && isColumnInterfaceHidden(list)) return
            if (!isAllowedCurrent) {
              const fallback = Array.from(options).find((wrap) => {
                const inp = wrap.querySelector('input[type="radio"]')
                const tokens = getTemplateTokens(wrap, inp)
                const allowed = !shouldRestrict || tokens.some((token) => allowedSet.has(token))
                return allowed && inp && !inp.disabled && wrap.style.display !== 'none'
              })
              const fallbackInput = fallback ? fallback.querySelector('input[type="radio"]') : null
              if (fallbackInput && !fallbackInput.checked) {
                fallbackInput.checked = true
                fallbackInput.dispatchEvent(new Event('change', { bubbles: true }))
              }
            }
          }
        })
      } catch (err) {
        console.warn('Options.setAllowedColumnTemplates failed:', err)
      }
    },

    // Ensure a selected radio option remains visible; if hidden, select the nearest visible option
    // Requires current config to infer intended selection when nothing is checked.
    enforceOptionsVisibility(config = {}) {
      const lists = document.querySelectorAll('.options-list')
      lists.forEach((list) => {
        const groupName = list.getAttribute('visualizer')
        const isSectionExplicitlyHidden = (node) => {
          let cur = node
          while (cur && cur.nodeType === 1) {
            if (cur.classList && cur.classList.contains('visualizer-column-interface--hidden')) return true
            if (cur.hasAttribute && cur.hasAttribute('hidden')) return true
            const style = cur.style || {}
            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return true
            cur = cur.parentElement
          }
          return false
        }
        // If the entire list sits inside a tab/panel that is currently hidden, skip corrections
        if (isSectionExplicitlyHidden(list)) return

        const optionWrappers = Array.from(list.querySelectorAll('.admin__field-option'))
        if (optionWrappers.length === 0) return
        const radios = optionWrappers.map(w => w.querySelector('input[type="radio"]'))
        if (radios.filter(Boolean).length === 0) return

        const configValue = groupName ? config[groupName] : null

        // Honor saved doors-style from config only while it remains selectable.
        if (groupName === 'doors-style' && configValue != null) {
          const cfgToken = String(configValue).trim()
          const cfgIdx = optionWrappers.findIndex((w) =>
            w.classList.contains(`data-visualizer-value-${cfgToken}`)
          )
          if (cfgIdx !== -1) {
            const radio = radios[cfgIdx]
            if (radio && !radio.disabled) {
              if (!radio.checked) {
                radio.checked = true
                radio.dispatchEvent(new Event('change', { bubbles: true }))
              }
              return
            }
          }
        }

        // Special case: for doors-style we must auto-select even when the whole tab is hidden.
        // If exactly one enabled radio remains, select it ignoring visibility.
        if (groupName === 'doors-style') {
          const enabledRadios = radios.filter(r => r && !r.disabled)
          const currentlyChecked = radios.find(r => r && r.checked)
          const checkedIsDisabled = !!(currentlyChecked && currentlyChecked.disabled)
          if (enabledRadios.length === 1 && (!currentlyChecked || checkedIsDisabled)) {
            const r = enabledRadios[0]
            const idx = radios.indexOf(r)
            const wrap = idx !== -1 ? optionWrappers[idx] : null
            const cls = wrap ? Array.from(wrap.classList || []).find((c) => c.startsWith('data-visualizer-value-')) : null
            const value = cls ? cls.replace('data-visualizer-value-', '') : r.value
            if (config && value) config[groupName] = value
            r.checked = true
            r.dispatchEvent(new Event('change', { bubbles: true }))
            return
          }
        }

        const isIndexSelectable = (idx) => {
          const wrap = optionWrappers[idx]
          const input = radios[idx]
          return !!wrap && !!input && !input.disabled && Options._isElementVisible(wrap)
        }

        let checkedIndex = radios.findIndex(r => r && r.checked)

        // If nothing is checked, try to infer the intended index from config value
        if (checkedIndex === -1 && configValue != null) {
          const cls = `data-visualizer-value-${configValue}`
          const refIdx = optionWrappers.findIndex(w => w.classList.contains(cls))
          if (refIdx !== -1 && !isIndexSelectable(refIdx)) {
            checkedIndex = refIdx
          } else if (refIdx !== -1) {
            const radio = radios[refIdx]
            if (radio && !radio.checked) {
              const change = new Event('change', { bubbles: true })
              radio.checked = true
              radio.dispatchEvent(change)
            }
            return
          }
        }

        if (checkedIndex === -1) {
          const firstSelectable = radios.findIndex((_, i) => isIndexSelectable(i))
          if (firstSelectable !== -1) {
            const radio = radios[firstSelectable]
            if (radio && !radio.checked) {
              const change = new Event('change', { bubbles: true })
              radio.checked = true
              radio.dispatchEvent(change)
            }
          }
          return
        }

        const currentWrapper = optionWrappers[checkedIndex]
        if (Options._isElementVisible(currentWrapper) && !radios[checkedIndex].disabled) return

        let left = null, right = null
        let dLeft = Infinity, dRight = Infinity
        for (let i = checkedIndex - 1; i >= 0; i--) {
          if (isIndexSelectable(i)) { left = i; dLeft = checkedIndex - i; break }
        }
        for (let i = checkedIndex + 1; i < optionWrappers.length; i++) {
          if (isIndexSelectable(i)) { right = i; dRight = i - checkedIndex; break }
        }

        let targetIndex = null
        if (left === null && right === null) {
          targetIndex = radios.findIndex((_, i) => isIndexSelectable(i))
          if (targetIndex === -1) return
        } else if (dLeft === dRight) {
          targetIndex = right ?? left
        } else {
          targetIndex = dLeft < dRight ? left : right
        }

        const targetRadio = targetIndex !== null ? radios[targetIndex] : null
        if (targetRadio && !targetRadio.checked) {
          const change = new Event('change', { bubbles: true })
          targetRadio.checked = true
          targetRadio.dispatchEvent(change)
        }
      })
    },

    updateColumnInterfaceVisibility(config = {}) {
      const HIDDEN_CLASS = 'visualizer-column-interface--hidden'
      const PREFIXES = [
        'columnTemplate-',
        'columnDividerHeight-',
        'columnShelvesCount-',
        'columnDrawersCount-',
        'doors-simpleOpeningDirection-',
      ]
      try {
        Options._syncColumnsCountFromDom(config)
        const columnsCount = Options._getColumnsCount(config)
        let selectedColumn = null
        const list = document.querySelector('.options-list[visualizer="columnVisibility"]')
        if (list) {
          const checked = list.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked')
          if (checked) {
            const wrap = checked.closest('.admin__field-option')
            const cls = wrap ? Array.from(wrap.classList || []).find((c) => c.startsWith('data-visualizer-value-')) : null
            if (cls) {
              const val = cls.replace('data-visualizer-value-', '')
              const n = parseInt(val, 10)
              if (Number.isFinite(n)) selectedColumn = n
            }
          }
        }
        if (selectedColumn === null && config && config.columnVisibility != null) {
          const v = config.columnVisibility
          const n = parseInt(v, 10)
          if (Number.isFinite(n)) selectedColumn = n
        }

        let selectionClamped = false
        if (selectedColumn === null || selectedColumn < 1 || selectedColumn > columnsCount) {
          selectedColumn = 1
          selectionClamped = true
        }

        if (selectionClamped && config) {
          config.columnVisibility = String(selectedColumn)
          if (list) {
            const wrap = list.querySelector(`.admin__field-option.data-visualizer-value-${selectedColumn}`)
            const input = wrap ? wrap.querySelector('input[type="radio"]') : null
            if (input && !input.checked) {
              input.checked = true
              input.dispatchEvent(new Event('change', { bubbles: true }))
            }
          }
        }

        const getContainer = (el) =>
          el.closest('tr.fields') || el.closest('tr') || el.closest('.field') || el.closest('.admin__field') || el.parentElement || el

        PREFIXES.forEach((prefix) => {
          document.querySelectorAll(`[visualizer^="${prefix}"]`).forEach((el) => {
            const vis = el.getAttribute('visualizer') || ''
            const m = vis.match(new RegExp(prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '(\\d+)', 'i'))
            const columnIndex = m ? parseInt(m[1], 10) : null
            if (columnIndex === null) return

            const container = getContainer(el)
            if (!container) return

            const shouldHide = selectedColumn !== null && columnIndex !== selectedColumn
            if (shouldHide) {
              container.classList.add(HIDDEN_CLASS)
              container.setAttribute('aria-hidden', 'true')
            } else {
              container.classList.remove(HIDDEN_CLASS)
              container.removeAttribute('aria-hidden')
            }
          })
        })

        if (selectionClamped) {
          const Form = global.Visualizer && global.Visualizer.Helpers && global.Visualizer.Helpers.Form
          if (Form && typeof Form.reapplyOptionsFromConfig === 'function') {
            Form.reapplyOptionsFromConfig(config, document, { onlyColumnScoped: true })
          }
          if (Form && typeof Form.reapplyScalarInputsFromConfig === 'function') {
            Form.reapplyScalarInputsFromConfig(config, document, { onlyColumnScoped: true })
          }
        }
      } catch (err) {
        console.warn('Options.updateColumnInterfaceVisibility failed:', err)
      }
    },

    // Show/disable allowed opening directions per door column.
    // allowed: Array where allowed[i] is ["rtl"], ["ltr"], or ["rtl","ltr"]. Index 0 => column 1.
    setDoorOpeningDirectionsAllowed(allowed, config = {}) {
      try {
        // NOTE: This rule targets the legacy openingDirection groups only.
        // The simpleOpeningDirection groups are intended to remain as plain Left/Right buttons per door.
        const lists = document.querySelectorAll('.options-list[visualizer^="doors-openingDirection-"]')
        lists.forEach((list) => {
          const vis = list.getAttribute('visualizer') || ''
          const m = vis.match(/doors-openingDirection-(\d+)/)
          if (!m) return
          const idx = parseInt(m[1], 10) - 1
          const allowedForCol = Array.isArray(allowed) ? allowed[idx] : null

          const rtlWrap = list.querySelector('.data-visualizer-value-rtl')
          const ltrWrap = list.querySelector('.data-visualizer-value-ltr')
          const rtlInput = rtlWrap ? rtlWrap.querySelector('input[type="radio"]') : null
          const ltrInput = ltrWrap ? ltrWrap.querySelector('input[type="radio"]') : null

          const enableBoth = !Array.isArray(allowedForCol) || allowedForCol.length === 0
          const rtlAllowed = enableBoth || allowedForCol.includes('rtl')
          const ltrAllowed = enableBoth || allowedForCol.includes('ltr')

          const apply = (wrap, input, visible) => {
            if (!wrap || !input) return
            wrap.style.display = visible ? '' : 'none'
            input.disabled = !visible
          }

          apply(rtlWrap, rtlInput, !!rtlAllowed)
          apply(ltrWrap, ltrInput, !!ltrAllowed)

          // If exactly one direction is allowed, auto-select it even if the list is hidden by the toggle UI
          const onlyRtl = !!rtlAllowed && !ltrAllowed
          const onlyLtr = !!ltrAllowed && !rtlAllowed
          if (onlyRtl && rtlInput && !rtlInput.checked) {
            rtlInput.checked = true
            rtlInput.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (onlyLtr && ltrInput && !ltrInput.checked) {
            ltrInput.checked = true
            ltrInput.dispatchEvent(new Event('change', { bubbles: true }))
          }
        })

        // Ensure current selections are valid after toggling
        Options.enforceOptionsVisibility(config)
      } catch (err) {
        console.warn('Options.setDoorOpeningDirectionsAllowed failed:', err)
      }
    }
,
    // Arrange door opening option groups (1018–1022) into a single row with one visible heading.
    // Pure DOM structure + classes; styling is handled by CSS.
    arrangeDoorOpeningGroups(config = {}) {
      try {
        // Collect opening-direction fields by visualizer attribute to avoid touching unrelated options like Door style
        // Only legacy openingDirection groups participate in this UI rearrangement.
        const lists = Array.from(document.querySelectorAll('.options-list[visualizer^="doors-openingDirection-"]'))
          // sort by numeric index to keep intended order
          .sort((a, b) => {
            const ai = parseInt((a.getAttribute('visualizer') || '').match(/(\d+)/)?.[0] || '0', 10)
            const bi = parseInt((b.getAttribute('visualizer') || '').match(/(\d+)/)?.[0] || '0', 10)
            return ai - bi
          })
        const fields = []
        lists.forEach((list) => {
          const field =
            list.closest('.field, [class*="fieldset"]') ||
            list.closest('[visualizer]') ||
            list
          if (field) fields.push(field)
        })
        if (fields.length === 0) return

        const firstField = fields[0]
        const firstTr = firstField.closest('tr.fields')
        const firstTd = firstField.closest('td') || (firstTr ? firstTr.querySelector('td') : null)
        if (!firstTd) return

        // Determine if the original DPO groups are explicitly hidden by the app (inline/attr),
        // and whether there is at least one enabled radio (ignore computed visibility to avoid self-lock).
        const isGroupExplicitlyHidden = (wrap) => {
          if (!wrap) return true
          // Check only direct attributes/inline styles so our own ancestor-hidden class doesn't affect it
          if (wrap.hasAttribute('hidden')) return true
          const ds = (wrap.style && wrap.style.display) || ''
          const vis = (wrap.style && wrap.style.visibility) || ''
          const op = (wrap.style && wrap.style.opacity) || ''
          if (ds === 'none' || vis === 'hidden' || op === '0') return true
          return false
        }
        // If all dynamic_option wrappers are explicitly hidden, we should hide the entire row
        const allOriginalHidden = fields.every((f) => {
          const wrap =
            f.closest('.field, [class*="fieldset"]') ||
            f.closest('[visualizer]') ||
            f
          return isGroupExplicitlyHidden(wrap)
        })
        // Check availability based solely on enabled radios, not visibility
        const anyEnabled = lists.some((list) => {
          const rtl = list.querySelector('.data-visualizer-value-rtl input[type="radio"]')
          const ltr = list.querySelector('.data-visualizer-value-ltr input[type="radio"]')
          return (rtl && !rtl.disabled) || (ltr && !ltr.disabled)
        })
        if (allOriginalHidden || !anyEnabled) {
          if (firstTr && !firstTr.classList.contains('doors-row-hidden')) firstTr.classList.add('doors-row-hidden')
          return
        } else {
          if (firstTr && firstTr.classList.contains('doors-row-hidden')) firstTr.classList.remove('doors-row-hidden')
        }

        // Ensure container exists under the first cell
        let container = firstTd.querySelector('.doors-inline-container')
        if (!container) {
          // Insert a heading text above the row as per mockup
          const heading = document.createElement('label')
          heading.className = 'required doors-inline-heading'
          heading.textContent = 'Choose the sides to open (tap to change)'
          // Place heading before the first field but within the same cell
          firstTd.insertBefore(heading, firstField)

          container = document.createElement('div')
          container.className = 'doors-inline-container'
          // Insert container right before the firstField so our UI appears above its internal list
          firstTd.insertBefore(container, firstField)
        }

        // Hide internal labels inside each field; mark groups and choices with classes
        fields.forEach((f) => {
          f.classList.add('doors-group')
          if (f === firstField) f.classList.add('doors-group-first')
          // Hide all native labels (Door Side 1..4); custom heading is used instead
          const innerLabel = f.querySelector(':scope > label')
          if (innerLabel) {
            try { innerLabel.style.setProperty('display', 'none', 'important') } catch(e) { innerLabel.style.display = 'none' }
            innerLabel.setAttribute('aria-hidden', 'true')
            innerLabel.setAttribute('hidden', '')
          }
          const list = f.querySelector('.options-list')
          if (list) list.classList.add('doors-options-list')
          const choices = f.querySelectorAll('.admin__field-option')
          choices.forEach((ch) => ch.classList.add('doors-choice'))
        })

        // Collapse original rows (TRs) only for the opening-direction groups to remove gaps
        // Keep the first row visible as the host row where we mounted the inline container and heading
        if (firstTr) firstTr.classList.add('doors-host-row')
        fields.forEach((f) => {
          const tr = f.closest('tr.fields')
          if (!tr) return
          if (tr === firstTr) return // do not hide the host row
          if (!tr.classList.contains('doors-row-hidden')) tr.classList.add('doors-row-hidden')
        })

        // Build proxy slots for our UI without moving originals
        if (!firstTd.__doorsProxyBuilt) {
          // Create slots matching the number of opening-direction groups found (max 4 supported)
          fields.forEach((_, idx) => {
            const slot = document.createElement('div')
            slot.className = 'doors-group'
            slot.setAttribute('data-doors-slot', String(idx + 1))
            container.appendChild(slot)
          })
          firstTd.__doorsProxyBuilt = true
        }

        // Show or hide proxy slots according to columns count
        const columns = Options._getColumnsCount(config)
        const slots = firstTd.querySelectorAll('.doors-inline-container > .doors-group[data-doors-slot]')
        slots.forEach((slot) => {
          const idx = Number(slot.getAttribute('data-doors-slot'))
          const shouldHide = Number.isFinite(idx) && idx > columns
          const isHidden = slot.classList.contains('doors-slot-hidden')
          if (shouldHide && !isHidden) {
            slot.classList.add('doors-slot-hidden')
            const btn = slot.querySelector('.door-toggle')
            if (btn) {
              if (!btn.hasAttribute('disabled')) btn.setAttribute('disabled', 'true')
              if (!btn.classList.contains('door-toggle--disabled')) btn.classList.add('door-toggle--disabled')
              // Do not show tooltip for invisible slot
              if (btn.hasAttribute('data-tooltip')) btn.removeAttribute('data-tooltip')
            }
          } else if (!shouldHide && isHidden) {
            slot.classList.remove('doors-slot-hidden')
            const btn = slot.querySelector('.door-toggle')
            if (btn) {
              if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled')
              if (btn.classList.contains('door-toggle--disabled')) btn.classList.remove('door-toggle--disabled')
            }
          }
        })
      } catch (e) {
        console.warn('Options.arrangeDoorOpeningGroups failed', e)
      }
    }
,
    // Transform each door-opening group into a single toggle button that shows the
    // currently selected direction and flips on click if allowed.
    // Non-destructive: radios remain in DOM (hidden) for form submission.
    makeDoorOpeningDirectionToggles(config = {}) {
      try {
        // Select strictly by visualizer attribute (do NOT rely on DPO-generated IDs).
        // Only legacy openingDirection groups are converted into single-toggle buttons.
        // The simpleOpeningDirection groups are intended to remain as 2-button Left/Right controls per door.
        const groups = document.querySelectorAll('.options-list[visualizer^="doors-openingDirection-"]')
        groups.forEach((list) => {
          // Find the index from visualizer attr
          const vis = list.getAttribute('visualizer') || ''
          const m = vis.match(/doors-openingDirection-(\d+)/)
          const idx = m ? parseInt(m[1], 10) : null

          // Locate the common container created by arrangeDoorOpeningGroups (no reliance on specific IDs)
          const container = document.querySelector('.doors-inline-container')
          const slot = (idx && container) ? container.querySelector(`.doors-group[data-doors-slot="${idx}"]`) : null
          if (!slot) return

          // Sync slot visibility with columns count
          const columns = Options._getColumnsCount(config)
          if (idx && idx > columns) {
            slot.classList.add('doors-slot-hidden')
          } else {
            slot.classList.remove('doors-slot-hidden')
          }

          // Build or reuse the toggle button inside the slot (leave originals intact)
          let toggle = slot.querySelector(':scope > .door-toggle')
          const ensureHidden = () => {
            // Move the original list off-screen but keep it in DOM for DPO
            list.classList.add('doors-original-hidden')
          }
          if (!toggle) {
            toggle = document.createElement('button')
            toggle.type = 'button'
            toggle.className = 'door-toggle'
            slot.appendChild(toggle)
            ensureHidden()
            // Save back reference for quick lookups
            list.__doorToggleEl = toggle

            // Bind click handler once
            toggle.addEventListener('click', (e) => {
              e.preventDefault()
              // Resolve radios each click (DOM may change)
              const rtlWrap = list.querySelector('.data-visualizer-value-rtl')
              const ltrWrap = list.querySelector('.data-visualizer-value-ltr')
              const rtl = rtlWrap ? rtlWrap.querySelector('input[type="radio"]') : null
              const ltr = ltrWrap ? ltrWrap.querySelector('input[type="radio"]') : null

              const current = rtl?.checked ? rtl : ltr?.checked ? ltr : null
              const other = current === rtl ? ltr : rtl

              // Determine if toggling is allowed irrespective of the list being hidden
              const otherWrapNode = (other === rtl ? rtlWrap : ltrWrap)
              const otherAllowed = other && otherWrapNode && !other.disabled && !(otherWrapNode && otherWrapNode.style && otherWrapNode.style.display === 'none')
              const disabled = toggle.classList.contains('door-toggle--disabled')
              if (!otherAllowed || disabled) return

              // Toggle selection programmatically
              other.checked = true
              other.dispatchEvent(new Event('change', { bubbles: true }))
            })

            // Keep toggle updated when radios change within this list
            list.addEventListener('change', () => {
              // Slight defer to allow external handlers to run
              setTimeout(() => Options.makeDoorOpeningDirectionToggles(config), 0)
            })
          } else {
            // Ensure list stays hidden if injected back by app
            ensureHidden()
          }

          // Update visual state and content on every call
          const rtlWrap = list.querySelector('.data-visualizer-value-rtl')
          const ltrWrap = list.querySelector('.data-visualizer-value-ltr')
          const rtl = rtlWrap ? rtlWrap.querySelector('input[type="radio"]') : null
          const ltr = ltrWrap ? ltrWrap.querySelector('input[type="radio"]') : null
          const currentWrap = rtl?.checked ? rtlWrap : ltr?.checked ? ltrWrap : null
          const other = rtl?.checked ? ltr : ltr?.checked ? rtl : null
          const otherWrap = other === rtl ? rtlWrap : ltrWrap

          // Build the content without recreating DOM nodes to avoid reloading images
          // Prefer image; fallback to label text
          const ensureImg = () => {
            let el = toggle.querySelector('img.door-toggle__img')
            if (!el) {
              el = document.createElement('img')
              el.className = 'door-toggle__img'
              el.decoding = 'async'
              el.loading = 'lazy'
              // Clear previous text node if any
              toggle.textContent = ''
              toggle.appendChild(el)
            }
            return el
          }
          const ensureText = () => {
            let el = toggle.querySelector('span.door-toggle__text')
            if (!el) {
              el = document.createElement('span')
              el.className = 'door-toggle__text'
              // Clear previous image if any
              const oldImg = toggle.querySelector('img.door-toggle__img')
              if (oldImg) oldImg.remove()
              toggle.textContent = ''
              toggle.appendChild(el)
            }
            return el
          }

          if (currentWrap) {
            const srcImg = currentWrap.querySelector('img')
            const label = currentWrap.querySelector('label span, label')
            if (srcImg && srcImg.getAttribute('src')) {
              const el = ensureImg()
              const newSrc = srcImg.getAttribute('src')
              const newAlt = srcImg.getAttribute('alt') || ''
              // Only update when changed to prevent extra network requests
              if (el.getAttribute('src') !== newSrc) el.setAttribute('src', newSrc)
              if (el.getAttribute('alt') !== newAlt) el.setAttribute('alt', newAlt)
            } else if (label) {
              const el = ensureText()
              const text = label.textContent || ''
              if (el.textContent !== text) el.textContent = text
            } else {
              const el = ensureText()
              if (el.textContent !== 'Door') el.textContent = 'Door'
            }
          }

          // Disabled state when other choice is not selectable (ignore parent visibility)
          const isOtherHiddenInline = !!(otherWrap && otherWrap.style && otherWrap.style.display === 'none')
          const canToggle = !!(other && otherWrap && !other.disabled && !isOtherHiddenInline)
          if (canToggle) {
            toggle.classList.remove('door-toggle--disabled')
            toggle.removeAttribute('disabled')
            toggle.removeAttribute('title')
            toggle.removeAttribute('data-tooltip')
          } else {
            toggle.classList.add('door-toggle--disabled')
            toggle.setAttribute('disabled', 'true')
            // Use custom tooltip via CSS instead of native title
            toggle.setAttribute('data-tooltip', 'Conflict with face divider')
            toggle.removeAttribute('title')
          }
        })
      } catch (err) {
        console.warn('Options.makeDoorOpeningDirectionToggles failed:', err)
      }
    }
    }

  // Door-specific dynamic limit setters
  ;(function attachDoorSetters(ns){
    try {
      // Internal: update noUi slider UI (range, handle, tooltip) if present next to the input
      function _updateNoUiSliderUI(control, input, min, max, current) {
        try {
          if (!control) control = input ? (input.closest('.control') || input.parentElement) : null
          const target = control ? control.querySelector('.noUi-target') : null
          if (!target) return
          const handle = target.querySelector('.noUi-handle')
          // Update underlying noUiSlider instance if available
          const slider = target && target.noUiSlider
          if (slider) {
            try {
              if (typeof slider.updateOptions === 'function') {
                slider.updateOptions({ range: { min: Number(min) || 0, max: Number(max) || Number(max) } }, false)
              }
            } catch (e) { /* non-fatal */ }
            try { if (typeof slider.set === 'function') slider.set([current]) } catch (e) { /* ignore */ }
          }
          // Update ARIA attributes and tooltip text to reflect new bounds/value
          if (handle) {
            handle.setAttribute('aria-valuemin', String(Number(min) || 0))
            if (Number.isFinite(Number(max))) handle.setAttribute('aria-valuemax', String(Number(max)))
            handle.setAttribute('aria-valuenow', String(current))
            const tip = handle.querySelector('.noUi-tooltip')
            if (tip && tip.textContent !== String(current)) tip.textContent = String(current)
          }
        } catch (e) {
          // best-effort UI sync
        }
      }

      // Helper to set numeric input max and clamp value with change events and sync UI (noUi)
      // Track and defer updates when user is actively interacting with the slider to prevent jitter
      function _attachInteractionListeners(input) {
        try {
          if (!input || input.__interactionBound) return
          const control = input.closest('.control') || input.parentElement
          const target = control ? control.querySelector('.noUi-target') : null
          if (!target) return
          const start = () => { input.__userSliding = true; target.__userSliding = true }
          const end = () => {
            input.__userSliding = false
            target.__userSliding = false
            // Apply any pending max after the drag ends
            if (input.__pendingMax != null) {
              const pending = input.__pendingMax
              input.__pendingMax = null
              // Force apply with clamping and UI sync now
              setMaxAndClamp(input, pending, true)
            }
          }
          ;['pointerdown','touchstart','mousedown'].forEach(ev => target.addEventListener(ev, start, { passive: true }))
          ;['pointerup','touchend','mouseup','touchcancel','pointercancel','blur'].forEach(ev => window.addEventListener(ev, end))
          input.__interactionBound = true
        } catch (e) { /* no-op */ }
      }
      function _isUserInteracting(input) {
        try {
          if (!input) return false
          if (input.__userSliding) return true
          const control = input.closest('.control') || input.parentElement
          const target = control ? control.querySelector('.noUi-target') : null
          return !!(target && target.__userSliding)
        } catch (e) { return false }
      }

      function setMaxAndClamp(input, max, forceApply) {
        if (!input) return
        _attachInteractionListeners(input)
        const prevMax = Number(input.getAttribute('max'))
        const maxNum = Number(max)
        const maxChanged = Number.isFinite(maxNum) && (!Number.isFinite(prevMax) || prevMax !== maxNum)
        if (maxChanged) input.setAttribute('max', String(maxNum))
        const minAttr = Number(input.getAttribute('min'))
        const minNum = Number.isFinite(minAttr) ? minAttr : 0
        let cur = Number(input.value)
        if (!Number.isFinite(cur)) cur = 0

        // If user is actively sliding and this is not a forced apply, defer heavy updates to avoid jitter
        if (!forceApply && _isUserInteracting(input)) {
          // Store the latest max to apply on interaction end
          input.__pendingMax = maxNum
          // Do not clamp value or touch the slider UI now; simply return
          return
        }

        let changed = false
        if (Number.isFinite(maxNum) && cur > maxNum) {
          cur = maxNum
          input.value = String(cur)
          changed = true
        }
        // Sync adjacent noUi slider UI regardless of whether value changed
        try { _updateNoUiSliderUI(input.closest('.control') || input.parentElement, input, minNum, maxNum, cur) } catch(e) {}
        if (changed) {
          input.dispatchEvent(new Event('input', { bubbles: true }))
          input.dispatchEvent(new Event('change', { bubbles: true }))
        } else if (maxChanged) {
          input.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }

      // Max hinges count: limit available radio options in list [visualizer="hinges-count"]
      // Allowed values in UI are discrete: 0, 2, 3, 4. The max caps which of these are available.
      // If a numeric input variant exists (legacy), we still clamp it for compatibility.
      Options.setDoorMaxHingesCount = function(maxHingesCount, config = {}) {
        try {
          const max = Number(maxHingesCount)
          if (!Number.isFinite(max)) return

          // 1) Preferred: operate on the radio options list
          const list = document.querySelector('.options-list[visualizer="hinges-count"]')
          if (list) {
            // Compute which discrete values are allowed under current max
            const allowed = new Set([0])
            if (max >= 2) allowed.add(2)
            if (max >= 3) allowed.add(3)
            if (max >= 4) allowed.add(4)

            // Map of value -> wrapper/input
            const wraps = {
              0: list.querySelector('.admin__field-option.data-visualizer-value-0'),
              2: list.querySelector('.admin__field-option.data-visualizer-value-2'),
              3: list.querySelector('.admin__field-option.data-visualizer-value-3'),
              4: list.querySelector('.admin__field-option.data-visualizer-value-4'),
            }

            // Show/hide and enable/disable each option
            Object.entries(wraps).forEach(([valStr, wrap]) => {
              if (!wrap) return
              const val = Number(valStr)
              const input = wrap.querySelector('input[type="radio"]')
              const visible = allowed.has(val)
              wrap.style.display = visible ? '' : 'none'
              if (input) input.disabled = !visible
            })

            // If current selection exceeds max, auto-select the highest allowed value
            const selected = list.querySelector('input[type="radio"]:checked')
            const selectedWrap = selected ? selected.closest('.admin__field-option') : null
            let selectedVal = null
            if (selectedWrap) {
              const cls = Array.from(selectedWrap.classList).find(c => c.startsWith('data-visualizer-value-'))
              if (cls) selectedVal = Number(cls.replace('data-visualizer-value-',''))
            }

            const isSelectedAllowed = selectedVal != null && allowed.has(selectedVal)
            if (!isSelectedAllowed) {
              // pick the highest allowed value (preference: 4 > 3 > 2 > 0)
              const preference = [4, 3, 2, 0]
              const targetVal = preference.find(v => allowed.has(v))
              const targetWrap = targetVal != null ? wraps[targetVal] : null
              const targetInput = targetWrap ? targetWrap.querySelector('input[type="radio"]') : null
              if (targetInput && !targetInput.checked && !targetInput.disabled && targetWrap && targetWrap.style.display !== 'none') {
                targetInput.checked = true
                // Update config and dispatch change event to trigger downstream handlers
                const change = new Event('change', { bubbles: true })
                targetInput.dispatchEvent(change)
              }
            }

            // Ensure overall form consistency after changes
            try { Options.enforceOptionsVisibility(config) } catch(e) {}

            return
          }

          // 2) Fallback: legacy numeric input path
          const legacyInput = document.querySelector('input[visualizer="hinges-count"]')
          if (legacyInput) {
            setMaxAndClamp(legacyInput, max)
          }
        } catch (err) {
          console.warn('Options.setDoorMaxHingesCount failed:', err)
        }
      }

      // Max hinge offsets: top and bottom (visualizer="top-hinge-offset" / "bottom-hinge-offset")
      Options.setDoorMaxHingeOffsets = function(maxTop, maxBottom, config = {}) {
        try {
          const top = document.querySelector('input[visualizer="top-hinge-offset"]')
          const bottom = document.querySelector('input[visualizer="bottom-hinge-offset"]')
          if (Number.isFinite(Number(maxTop))) setMaxAndClamp(top, Number(maxTop))
          if (Number.isFinite(Number(maxBottom))) setMaxAndClamp(bottom, Number(maxBottom))
        } catch (err) {
          console.warn('Options.setDoorMaxHingeOffsets failed:', err)
        }
      }

      // Configurable border support toggles whether stile/rail width inputs are usable
      // Additionally hide/show their UI wrappers so users cannot interact when unsupported
      Options.setDoorSupportsConfigurableBorder = function(supports, config = {}) {
        try {
          const enable = !!supports
          const stile = document.querySelector('input[visualizer="stile-width"]')
          const rail = document.querySelector('input[visualizer="rail-width"]')

          function toggleFieldVisibility(inputEl, show) {
            if (!inputEl) return
            // Find the nearest visual field wrapper to hide the whole control (including slider/buttons)
            const field = inputEl.closest('.field') || inputEl.closest('tr.fields') || inputEl.closest('.control') || inputEl.parentElement
            if (field) {
              field.style.display = show ? '' : 'none'
              field.setAttribute('aria-hidden', show ? 'false' : 'true')
            }
            // Toggle disabled on the input itself
            if (show) {
              inputEl.removeAttribute('disabled')
            } else {
              inputEl.setAttribute('disabled', 'true')
            }
            // Best-effort: also disable/enable range buttons if present
            try {
              const control = inputEl.closest('.product-options__range') || inputEl.closest('.control')
              if (control) {
                control.querySelectorAll('.product-options__range-button').forEach((btn) => {
                  if (show) btn.removeAttribute('disabled')
                  else btn.setAttribute('disabled', 'true')
                })
              }
            } catch(e) { /* no-op */ }

            // Trigger a change so dependent logic (URL saving, validation) can react
            inputEl.dispatchEvent(new Event('change', { bubbles: true }))
          }

          toggleFieldVisibility(stile, enable)
          toggleFieldVisibility(rail, enable)

          // Ensure overall form consistency after visibility changes
          try { Options.enforceOptionsVisibility(config) } catch(e) {}
        } catch (err) {
          console.warn('Options.setDoorSupportsConfigurableBorder failed:', err)
        }
      }

      Options.setDoorConfigurableWidthRange = function(stileRange, railRange, config = {}) {
        try {
          const stile = document.querySelector('input[visualizer="stile-width"]')
          const rail = document.querySelector('input[visualizer="rail-width"]')

          const normalizeRange = (range) => {
            if (!range || typeof range !== 'object') return {}
            const rawMin = Number(range.min)
            const rawMax = Number(range.max)
            const hasMin = Number.isFinite(rawMin)
            const hasMax = Number.isFinite(rawMax)
            if (hasMin && hasMax) {
              if (rawMin <= rawMax) return { min: rawMin, max: rawMax }
              return { min: rawMin, max: rawMin }
            }
            if (hasMin) return { min: rawMin, max: rawMin }
            if (hasMax) return { min: rawMax, max: rawMax }
            return {}
          }

          const applyRange = (input, range) => {
            if (!input) return
            const normalized = normalizeRange(range)
            const min = normalized.min
            const max = normalized.max
            const hasMin = Number.isFinite(min)
            const hasMax = Number.isFinite(max)
            if (!hasMin && !hasMax) return

            if (hasMin) input.setAttribute('min', String(min))
            if (hasMax) setMaxAndClamp(input, max, true)

            let cur = Number(input.value)
            const fallback = hasMin ? min : (hasMax ? max : 0)
            let changed = false
            if (!Number.isFinite(cur)) {
              cur = fallback
              input.value = String(cur)
              changed = true
            }
            if (hasMin && cur < min) {
              cur = min
              input.value = String(cur)
              changed = true
            }
            if (hasMax && cur > max) {
              cur = max
              input.value = String(cur)
              changed = true
            }
            if (changed) {
              input.dispatchEvent(new Event('input', { bubbles: true }))
              input.dispatchEvent(new Event('change', { bubbles: true }))
            }
          }
          applyRange(stile, stileRange)
          applyRange(rail, railRange)
        } catch (err) {
          console.warn('Options.setDoorConfigurableWidthRange failed:', err)
        }
      }

      Options.setDoorMaxConfigurableWidths = function(maxStile, maxRail, config = {}) {
        try {
          const stile = document.querySelector('input[visualizer="stile-width"]')
          const rail = document.querySelector('input[visualizer="rail-width"]')
          if (Number.isFinite(Number(maxStile))) setMaxAndClamp(stile, Number(maxStile))
          if (Number.isFinite(Number(maxRail))) setMaxAndClamp(rail, Number(maxRail))
        } catch (err) {
          console.warn('Options.setDoorMaxConfigurableWidths failed:', err)
        }
      }
    } catch (e) {
      console.warn('Attach door setters failed:', e)
    }
  })(Options)

  Options.isSlimlineFrameStyle = function(config = {}) {
    try {
      const frameStyle = config['frameStyle'] || config['frame-style'] || null
      if (!frameStyle) {
        return false
      }
      const frameStyleStr = String(frameStyle).toLowerCase().trim()
      return frameStyleStr === 'slimline'
    } catch (err) {
      console.warn('Options.isSlimlineFrameStyle failed:', err)
      return false
    }
  }

  global.Visualizer = global.Visualizer || {}
  global.Visualizer.Helpers = global.Visualizer.Helpers || {}
  global.Visualizer.Helpers.Options = Options

  // ---------------------------------------------------------------------------
  // Make doors-simpleOpeningDirection-* buttons fully clickable (no layout hacks).
  // DPO markup differs across builds; sometimes only label/img clicks toggle input.
  // We delegate a click on the wrapper to the underlying input.
  // ---------------------------------------------------------------------------
  ;(function installSimpleDoorDirFullClick(){
    const LIST_SEL = '.options-list[visualizer^="doors-simpleOpeningDirection-"]'
    const BTN_SEL = '.door-dir-btn'

    function handleClick(e) {
      try {
        const target = e && e.target
        if (!target || !target.closest) return
        const list = target.closest(LIST_SEL)
        if (!list) return
        const btn = target.closest(BTN_SEL)
        if (!btn || !list.contains(btn)) return

        // If click is already on an interactive element, let it proceed naturally
        const tag = (target.tagName || '').toLowerCase()
        if (tag === 'input' || tag === 'label' || tag === 'a' || tag === 'button') return

        // Find the actual input controlling this option
        const input =
          btn.querySelector('input[type="radio"], input[type="checkbox"]') ||
          btn.closest('.admin__field-option')?.querySelector('input[type="radio"], input[type="checkbox"]') ||
          null
        if (!input) return
        if (input.disabled) return

        // Trigger selection
        input.click()
      } catch (err) {
        // best-effort
      }
    }

    function installOnce() {
      try {
        if (document.__vizSimpleDoorDirFullClickInstalled) return
        document.addEventListener('click', handleClick, true)
        document.__vizSimpleDoorDirFullClickInstalled = true
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', installOnce)
    } else {
      installOnce()
    }
  })()
})(window);
